import { render, staticRenderFns } from "./CreateTicimaxV2Channel.vue?vue&type=template&id=4c50bd46&scoped=true"
import script from "./CreateTicimaxV2Channel.vue?vue&type=script&lang=js"
export * from "./CreateTicimaxV2Channel.vue?vue&type=script&lang=js"
import style0 from "./CreateTicimaxV2Channel.vue?vue&type=style&index=0&id=4c50bd46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c50bd46",
  null
  
)

export default component.exports